import { ImportResult } from '../../src/models/domain/importResult'

import { CipherType } from '../../src/enums/cipherType'
import { SecureNoteType } from '../../src/enums/secureNoteType'
import { Importer } from './importer'
import { BaseImporter } from './baseImporter'

export class AvastJsonImporter extends BaseImporter implements Importer {
  parse(data: string): Promise<ImportResult> {
    const result = new ImportResult()
    const results = JSON.parse(data)
    if (results == null) {
      result.success = false
      return Promise.resolve(result)
    }

    if (results.logins != null) {
      // CS
      const existingKeys = ['custName', 'note', 'url', 'pwd']

      results.logins.forEach((value: any) => {
        const cipher = this.initLoginCipher()
        cipher.name = this.getValueOrDefault(value.custName)
        cipher.notes = this.getValueOrDefault(value.note)
        cipher.login.uris = this.makeUriArray(value.url)
        cipher.login.password = this.getValueOrDefault(value.pwd)
        cipher.login.username = this.getValueOrDefault(value.custName)

        // CS
        Object.keys(value)
          .filter(k => !existingKeys.includes(k))
          .forEach(k => {
            this.processKvp(cipher, k, value[k])
          })

        this.cleanupCipher(cipher)
        result.ciphers.push(cipher)
      })
    }

    if (results.notes != null) {
      // CS
      const existingKeys = ['label', 'text']

      results.notes.forEach((value: any) => {
        const cipher = this.initLoginCipher()
        cipher.type = CipherType.SecureNote
        cipher.secureNote.type = SecureNoteType.Generic
        cipher.name = this.getValueOrDefault(value.label)
        cipher.notes = this.getValueOrDefault(value.text)

        // CS
        Object.keys(value)
          .filter(k => !existingKeys.includes(k))
          .forEach(k => {
            this.processKvp(cipher, k, value[k])
          })

        this.cleanupCipher(cipher)
        result.ciphers.push(cipher)
      })
    }

    if (results.cards != null) {
      // CS
      const existingKeys = [
        'custName',
        'note',
        'holderName',
        'cardNumber',
        'cvv',
        'expirationDate',
      ]

      results.cards.forEach((value: any) => {
        const cipher = this.initLoginCipher()
        cipher.type = CipherType.Card
        cipher.name = this.getValueOrDefault(value.custName)
        cipher.notes = this.getValueOrDefault(value.note)
        cipher.card.cardholderName = this.getValueOrDefault(value.holderName)
        cipher.card.number = this.getValueOrDefault(value.cardNumber)
        cipher.card.code = this.getValueOrDefault(value.cvv)
        cipher.card.brand = this.getCardBrand(cipher.card.number)
        if (value.expirationDate != null) {
          if (value.expirationDate.month != null) {
            cipher.card.expMonth = value.expirationDate.month + ''
          }
          if (value.expirationDate.year != null) {
            cipher.card.expYear = value.expirationDate.year + ''
          }
        }

        // CS
        Object.keys(value)
          .filter(k => !existingKeys.includes(k))
          .forEach(k => {
            this.processKvp(cipher, k, value[k])
          })

        this.cleanupCipher(cipher)
        result.ciphers.push(cipher)
      })
    }

    result.success = true
    return Promise.resolve(result)
  }
}
